if (typeof ProductQuantity !== 'function') {
  class ProductQuantity extends HTMLElement {
    constructor() {
      super();

      const qty = this.querySelector('.qty-selector');
      const qtyMinus = this.querySelector('.qty-minus');
      const qtyPlus = this.querySelector('.qty-plus');

      let qtyMin = parseInt(qty.getAttribute('min')) || 1;
      let qtyMax = parseInt(qty.getAttribute('max')) || 999;
      let qtyStep = parseInt(qty.getAttribute('step')) || 1;

      const updateButtonStates = () => {
        if (parseInt(qty.value) - qtyStep < qtyMin) {
          qtyMinus.classList.add('disabled');
        } else {
          qtyMinus.classList.remove('disabled');
        }
        if (parseInt(qty.value) + qtyStep > qtyMax) {
          qtyPlus.classList.add('disabled');
        } else {
          qtyPlus.classList.remove('disabled');
        }
      };

      updateButtonStates();

      qty.addEventListener('change', () => {
        updateButtonStates();
      });

      qty.addEventListener('input', () => {
        updateButtonStates();
      });

      qtyMinus.addEventListener('click', (e) => {
        e.preventDefault();
        if (!qtyMinus.classList.contains('disabled')) {
          const currentQty = parseInt(qty.value);
          const newQty = currentQty - qtyStep;
          if (newQty >= qtyMin) {
            qty.value = newQty;
            qty.dispatchEvent(new Event('change', { bubbles: true }));
            updateButtonStates();
          }
        }
      });

      qtyPlus.addEventListener('click', (e) => {
        e.preventDefault();
        if (!qtyPlus.classList.contains('disabled')) {
          const currentQty = parseInt(qty.value);
          const newQty = currentQty + qtyStep;
          if (newQty <= qtyMax) {
            qty.value = newQty;
            qty.dispatchEvent(new Event('change', { bubbles: true }));
            updateButtonStates();
          }
        }
      });

      this._observer = new MutationObserver((mutations) => {
        for (const m of mutations) {
          if (m.attributeName === 'min') qtyMin = parseInt(qty.getAttribute('min')) || 1;
          if (m.attributeName === 'max') qtyMax = parseInt(qty.getAttribute('max')) || 999;
          if (m.attributeName === 'step') qtyStep = parseInt(qty.getAttribute('step')) || 1;
        }
        updateButtonStates();
      });
      this._observer.observe(qty, { attributes: true, attributeFilter: ['min', 'max', 'step'] });
    }

    disconnectedCallback() {
      if (this._observer) {
        this._observer.disconnect();
        this._observer = null;
      }
    }
  }

  if (typeof customElements.get('product-quantity') == 'undefined') {
    customElements.define('product-quantity', ProductQuantity);
  }
}
